export default __webpack_public_path__ + "static/media/default_image.e73a6205.png";